import axios from "axios"
import {format} from "date-fns"

const init = () => {

	const products = document.querySelector('[data-products]')

	if (products !== null) {

		const step                   = document.querySelector('[data-booking-step]')
		const overviewEndpoint       = products.getAttribute('data-products-overview-endpoint')
		const productSelectedAttr    = 'data-product-selected'
		const productSelectedClass   = 'booking-products-item--selected'
		const btnOffText             = 'Add'
		const btnOnText              = 'Remove'
		const loadingClass           = 'is-loading'
		const overviewContainer      = step.querySelector('[data-overview-container]')
		const overviewContainerInner = step.querySelector('[data-overview-container-inner]')

		const checkStepValidity = () => {
			
			let isValid = true
			
			// Loop through all current selected products
			for (const product of products.querySelectorAll('[' + productSelectedAttr + ']')) {

				let hasOptionSelected = false

				for (const fld of product.querySelectorAll('[data-variant-id]')) {

					if (parseInt(fld.value) > 0) {
						hasOptionSelected = true
					}
				}

				if (hasOptionSelected === false) {

					isValid = false
					break
				}
			}

			// Dispatch event to show current step validity
			const ev = new CustomEvent('step-validity-change', {
				bubbles: true,
				detail: isValid
			})
			products.dispatchEvent(ev)
		}

		for (const product of products.querySelectorAll('[data-product]')) {

			// Listen for when action button (Add/Remove) clicked
			product.addEventListener('action-clicked', (e) => {

				console.log('action clicked');

				// Get checkbox
				const chkbox = product.querySelector('[data-product-checkbox]')

				// Toggle checkbox
				chkbox.checked = !chkbox.checked

				// Get action btn
				const btn = product.querySelector('[data-product-btn]')

				btn.innerHTML = (btn.innerHTML === btnOffText) ? btnOnText : btnOffText

				// Toggle attribute and class to show product is selected/unselected
				product.toggleAttribute(productSelectedAttr)
				product.classList.toggle(productSelectedClass)

				// If product contains a timeslot field, toggle required attribute on it
				const timeslotFld = product.querySelector('[data-timeslot]')
				if (timeslotFld !== null) {
					timeslotFld.toggleAttribute('required')
				}

				getOverview()
				checkStepValidity()
			})

			// Listen for when 'price-per' field has been changed
			product.addEventListener('price-per-changed', (e) => {

				console.log(e);

				let total    = 0
				let adults   = 0
				let children = 0

				// Loop through 'price-per' fields in this product to calculate new price
				for (const fld of product.querySelectorAll('[data-price-per]')) {

					const pricePer = (fld.getAttribute('data-price-per') * 1)
					const num      = (fld.value * 1)

					// Add to total price
					total += pricePer * num

					// Increment number of adults or children
					switch (fld.getAttribute('data-attendee-type')) {

						case 'adult':
							adults += num
							break
						
						case 'child':
							children += num

					}
				}

				product.querySelector('[data-product-price]').innerHTML = total.toFixed(2)

				const strAttendees = adults + ' ' + ((adults == 1) ? 'Adult' : 'Adults') + ', ' + children + ' ' + ((children == 1) ? 'Child' : 'Children')
				
				product.querySelector('[data-product-attendees]').innerHTML = strAttendees
			})
		}

		// Loop through action buttons
		for (const btn of products.querySelectorAll('[data-product-btn]')) {

			// Add event listener to dispatch 'action-clicked' event when clicked.
			btn.addEventListener('click', (e) => {

				const ev = new Event('action-clicked', {
					bubbles: true
				})
				btn.dispatchEvent(ev)
			})
		}

		// Loop through any fields that contain a 'price per' value
		for (const fld of products.querySelectorAll('[data-price-per]')) {

			// Add event listener to dispatch 'price-per-changed' event when clicked.
			fld.addEventListener('change', (e) => {

				// Get price per for this field
				const pricePer = (fld.getAttribute('data-price-per') * 1)
				
				// Dispatch event
				const ev = new CustomEvent('price-per-changed', {
					bubbles: true,
					detail: pricePer
				})
				fld.dispatchEvent(ev)
			})

		}

		// Loop through variant and timeslot fields
		for (const fld of products.querySelectorAll('[data-variant-id], [data-timeslot]')) {

			// Reload overview whenever variant field changed
			fld.addEventListener('change', () => {
				getOverview()
				checkStepValidity()
			})
		}

		// Loop through variant fields
		for (const fld of products.querySelectorAll('[data-variant-id]')) {

			fld.addEventListener('change', () => {

				const ev = new Event('variant-changed', {
					bubbles: true
				})
				fld.dispatchEvent(ev)
			})
		}

		// Listen for when variant changed on products with timeslots
		for (const product of products.querySelectorAll('[data-has-timeslots]')) {

			product.addEventListener('variant-changed', (e) => {

				getEventTimeslotOptions(product)
			})
		}

		const getEventTimeslotOptions = (productEl) => {

			const timeslotsFld = productEl.querySelector('[data-timeslot]')
			const fldParent    = timeslotsFld.closest('.booking-product-options__field')

			fldParent.classList.toggle(loadingClass)

			// Remove error message if it exists
			const errorMsg = fldParent.querySelector('.error')
			if (errorMsg !== null) {
				errorMsg.remove()
			}

			let totalVisitors = 0

			for (const variant of productEl.querySelectorAll('[data-variant-id]')) {

				totalVisitors += parseInt(variant.value)
			}

			const url = new URL('/data/event-time-slots', window.location.origin)

			// Url params
			url.searchParams.append('visitors', totalVisitors)
			url.searchParams.append('productId', productEl.getAttribute('data-product-id'))
			url.searchParams.append('cachebust', format(new Date(), 't')) // Cachebust param
			
			// Ajax call
			axios
				.get(url.href)
				.then((response) => {
					console.log(response)

					const timeslots = response.data.data

					let stepIsValid = true
					
					// If no timeslots available, prevent progress
					if (timeslots.length === 0) {

						stepIsValid = false

						// TODO: Show error message in place of timeslot field
						timeslotsFld.disabled = true

						const msg = document.createElement('div')
						msg.classList.add('error')
						msg.innerHTML = "There are no timeslots on this date with capacity for the number of people selected"

						fldParent.appendChild(msg)

					} else {

						timeslotsFld.disabled = false

						// Clear current timeslots options and re-select first option
						// timeslotsFld[0].disabled = false
						timeslotsFld.length = 1
						timeslotsFld.value  = ''

						// Loop through returned available timeslots
						for (const ts of timeslots) {

							// Add relevant options to timeslots field
							const opt = document.createElement('option')
							opt.value = ts
							opt.text  = ts

							timeslotsFld.add(opt, null)

							// if (ts === chosenTimeslot) {
							// 	hasValue = true
							// }
						}
					}

					const ev = new CustomEvent('step-validity-change', {
						bubbles: true,
						detail: false
					})
					productEl.dispatchEvent(ev)

					fldParent.classList.toggle(loadingClass)
				})
		}

		const getOverview = () => {
			
			overviewContainer.classList.add(loadingClass)
			// overviewContainerInner.innerHTML = ''

			const productItems = []

			// Loop through selected products to pass to overview
			for (const product of products.querySelectorAll('[data-product-selected]')) {
				
				// Get product id of product
				const productData = {
					productId: parseInt(product.getAttribute('data-product-id'))
				}

				const variants = []

				// Loop through variant fields in the product
				for (const fld of product.querySelectorAll('[data-variant-id]')) {

					const variantId = parseInt(fld.getAttribute('data-variant-id'))

					variants.push({
						id: variantId,
						num: parseInt(fld.value)
					})
				}

				// Add variants to productData object
				productData.variants = variants

				// Add timeslot field for this product if available
				const timeslotFld = product.querySelector('[data-timeslot]')
				if (timeslotFld !== null) {
					productData.timeslot = timeslotFld.value
				}
				
				// Add productData to products array
				productItems.push(productData)
			}

			const formData = new FormData()
			formData.append('products', JSON.stringify(productItems))
			formData.append(window.csrfTokenName, window.csrfTokenValue)

			const url = new URL('/data/' + overviewEndpoint, window.location.origin)

			// Url params
			url.searchParams.append('cachebust', format(new Date(), 't')) // Cachebust param
			
			// Ajax call
			axios
				.post(url.href, formData)
				.then((response) => {
					// console.log(response)
					overviewContainerInner.innerHTML = response.data.html
					overviewContainer.classList.remove(loadingClass)
				})
		}

		getOverview()

	}
}

export default function() {
    init();
}